export default __webpack_public_path__ + "static/media/P17.25485d53.png";